import { PayloadAction } from "@reduxjs/toolkit";
import {
  ProposalReduxState,
  ProposalSlidesType,
  ProposalSlideType,
} from "../types";

const SetProposalSlides = (
  state: ProposalReduxState,
  { payload }: PayloadAction<{ slides: ProposalSlidesType[] }>,
) => {
  const { slides } = payload;

  state.slides = slides;
};

const UpdateProposalSlide = (
  state: ProposalReduxState,
  {
    payload,
  }: PayloadAction<{
    index: number;
    nameKey: string;
    slide: ProposalSlideType;
  }>,
) => {
  const { index, nameKey, slide } = payload;

  if (!state.slides) state.slides = [];
  const nameKeyIndex = state.slides.findIndex(
    (slideGroup) => slideGroup.nameKey === nameKey,
  );

  if (nameKeyIndex > -1 && state.slides[nameKeyIndex].slides[index]) {
    state.slides[nameKeyIndex].slides[index] = slide;
  }
};

const SetProposalProgression = (
  state: ProposalReduxState,
  { payload: progress }: PayloadAction<number>,
) => {
  state.slidesGeneration.progress = progress;
};

const SetProposalError = (
  state: ProposalReduxState,
  { payload: isError }: PayloadAction<boolean>,
) => {
  state.slidesGeneration.isError = isError;
};

const SlidesReducers = {
  SetProposalSlides,
  UpdateProposalSlide,

  // Progession
  SetProposalError,
  SetProposalProgression,
};

export default SlidesReducers;
